import config from 'config';
import httpTimeout from '../http-timeout';
import wrapUrlWithServerUrl from '../utils/wrap-url-with-server-url';

export const patch = <TBody, TResponse>(url: string, data?: TBody) => {
    return httpTimeout<TResponse>(
        new Request(wrapUrlWithServerUrl(url), {
            body: JSON.stringify(data),
            ...config.fetch.patch,
        }),
    );
};

export default patch;
